import * as d3 from 'd3';
import {Delaunay} from "d3-delaunay";

const data = [
    { "year": 2001, "fatal": 1239, "accidents": 18505},
    { "year": 2002, "fatal": 1429, "accidents": 19686},
    { "year": 2003, "fatal": 1326, "accidents": 19976},
    { "year": 2004, "fatal": 1296, "accidents": 20957},
    { "year": 2005, "fatal": 1278, "accidents": 20777},
    { "year": 2006, "fatal": 1303, "accidents": 20977},
    { "year": 2007, "fatal": 1232, "accidents": 20635},
    { "year": 2008, "fatal": 996, "accidents": 19174},
    { "year": 2009, "fatal": 822, "accidents": 17864},
    { "year": 2010, "fatal": 740, "accidents": 16308},
    { "year": 2011, "fatal": 638, "accidents": 15827},
    { "year": 2012, "fatal": 605, "accidents": 15174},
    { "year": 2013, "fatal": 591, "accidents": 15691, "bold": true},
    { "year": 2014, "fatal": 626, "accidents": 15847},
    { "year": 2015, "fatal": 644, "accidents": 16331},
    { "year": 2016, "fatal": 607, "accidents": 16627},
    { "year": 2017, "fatal": 625, "accidents": 16489},
    { "year": 2018, "fatal": 633, "accidents": 16951, "bold": true}
];

export function timeseries(containerId, id, props, text, value = 'accidents') {
  const { width, height } = props;
  const chartWidth = width * 0.75;
  const chartHeight = height * 0.45;

  const margin = 40;

  const container = document.getElementById(containerId);

  let svg = d3.select('#' + id);
  if (svg.empty()) {
    svg = d3.select(container)
      .append('svg')
      .attr('id', id);
  }
  svg
    .style('width', width + 'px')
    .style('height', height + 'px')
    .attr("transform", `translate(${(width - chartWidth) / 2},
    ${(height - chartHeight) * 0.6})`);;

  const x = d3.scaleLinear()
    .domain(d3.extent(data, d => d.year))
    .range([margin, chartWidth - margin]);

  const max = d3.max(data, d => d[value]);
  const y = d3.scaleLinear()
    .domain([0, max * 1.1])
    .range([chartHeight, 0]);


  const t = d3.transition()
    .duration(2000);

  if (svg.select('#bottomAxis').empty()){
    svg.append("g")
      .attr('id', 'bottomAxis')
      .attr('transform', `translate(0, ${chartHeight})`)
      //.attr('font-size', width * 0.1 + 'px')
      .call(d3.axisBottom(x).tickFormat(d3.format("d")));
  } else {
    svg.select('#bottomAxis')
      .transition(t)
      .attr('transform', `translate(0, ${chartHeight})`)
      .call(d3.axisBottom(x).tickFormat(d3.format("d")));
  }
  const localeFormatter = d3.formatLocale({thousands: ' ', grouping: [3]});
  const format = d3.formatLocale({thousands: ' ', grouping: [3]}).format(',');

  if (svg.select('#axis').empty()) {
    svg
      .append('g')
      .attr('id', 'axis')
      .attr('transform', `translate(${margin}, 0)`)
      .call(d3.axisLeft(y).tickFormat(format));
  } else {
    svg.select('#axis')
      .transition(t)
      .call(d3.axisLeft(y).tickFormat(format));
  }

  const onEnter = (type, value) => enter => {
    const g = enter.append('g')
      .classed(type + 'Line', true);
    g.append('path')
        .classed(type, true)
        .datum(data)
          .attr("fill", "none")
          .attr("d", d3.line()
            .x(d => x(d.year))
            .y(d => y(d[type]))
          );

    g.append('text')
      .attr('transform', `translate(${chartWidth - margin * 2.5}, ${y(value)})`)
      .classed(type + 'Label', true)
      .attr('font-size', width * 0.027 + 'px')
      .attr('text-anchor', 'end')
      .text(text(type));
  }

  const onUpdate = (type, value) => update => {
    update.select('path')
        .call(update => update
          .datum(data)
          .transition(t)
          .attr("d", d3.line()
            .x(d => x(d.year))
            .y(d => y(d[type]))
          ));
    update.select('text')
      .call(text => text.transition(t)
        .attr('transform', `translate(${chartWidth - margin * 2.5}, ${y(value)})`)
        .attr('font-size', width * 0.027 + 'px')
      );
  }

  svg.selectAll('.accidentsLine')
    .data(['accidents'])
    .join(onEnter('accidents', 13000), onUpdate('accidents', 13000));

  svg.selectAll('.fatalLine')
    .data(['fatal'])
    .join(onEnter('fatal', (value === 'fatal' ? 400 : 2800)), onUpdate('fatal', (value === 'fatal' ? 400 : 2800)));

  const data2 = data.concat(data);
  const v = (d, i) => ({ year: d.year, value: (i < data2.length / 2 ? d.accidents : d.fatal)});
  const dData = data2.map(v);
  const delaunay = Delaunay
    .from(dData, d => x(d.year), d => y(d.value));

  svg.select("#point").remove();
  svg.append('circle')
    .attr('id', 'point')
    .attr('r', 0);


  svg.on("mousemove", function() {
    const [cx, cy] = d3.mouse(this);
    const index = delaunay.find(cx, cy);
    const d = dData[index];
    svg.select('#point')
      .attr('cx', x(d.year))
      .attr('cy', y(d.value))
      .attr('r', 5);

    d3.select('#tooltip')
      .style('left', x(d.year) + 'px')
      .style('top', y(d.value) + chartHeight * 0.60 + 'px')
      .classed('wide', true)
      .text(d.year + ': ' + format(d.value) + (index < dData.length / 2 ? ' baleset' : ' f\u0151'));
  });

  svg.on('mouseleave', () => d3.select('#tooltip')
    .style('left', -1000 + 'px'));

}